import styled from "styled-components";

const Button = styled.button`
  height: 56px;
  position: relative;
  display: flex;
  align-items: center;
  border: 1px solid rgba(150, 150, 150, 0.2);
  cursor: pointer;
  background: var(--accent);
  color: #fff;
  padding: 16px;
  box-sizing: border-box;
  border-radius: 4px;
  transition: all 0.2s ease;

  img {
    filter: brightness(0) invert(1);
    height: 24px;
    width: 24px;
    margin-left: 8px;
  }

  @media only screen and (max-width: 768px) {
    height: 48px;
    img {
      height: 24px;
      width: 24px;
      margin-left: 18px;
    }
  }

  &:focus {
    outline: none;
  }

  &:hover {
    background: var(--panel-bg);
    color: var(--text-color);
    img {
      filter: none;
    }
  }
`;

export default Button;
